import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const CampaignCategoryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default CampaignCategoryModule;